import * as types from './ReadActionType';

// Read Exam Data Start
export const fetchExamDataReadRequest = (data) => ({
    type: types.FETCH_EXAM_DATA_READ_REQUEST,
    payload: data
});
export const fetchExamDataReadSuccess = (data) => ({
    type: types.FETCH_EXAM_DATA_READ_SUCCESS,
    payload: data
});
export const fetchExamDataReadFailure = (error) => ({
    type: types.FETCH_EXAM_DATA_READ_FAILURE,
    payload: error
});

export const exportExamDataReadRequest = (data) => ({
    type: types.EXPORT_EXAM_DATA_READ_REQUEST,
    payload: data
});
export const exportExamDataReadSuccess = (data) => ({
    type: types.EXPORT_EXAM_DATA_READ_SUCCESS,
    payload: data
});
export const exportExamDataReadFailure = (error) => ({
    type: types.EXPORT_EXAM_DATA_READ_FAILURE,
    payload: error
});
// Read Exam Data End 